/**
 * Centralised debug logging utility.
 *
 * Enable in the browser console:  window.ODYSSEY_DEBUG = true
 */

declare global {
  interface Window {
    ODYSSEY_DEBUG?: boolean;
  }
}

export const isDebugEnabled = (): boolean =>
  typeof window !== "undefined" && window.ODYSSEY_DEBUG === true;

export const debugLog = (
  category: string,
  message: string,
  data?: unknown
): void => {
  if (!isDebugEnabled()) return;
  const timestamp = new Date().toISOString().slice(11, 23);
  if (data !== undefined) {
    console.log(`[${timestamp}][SDK:${category}] ${message}`, data);
  } else {
    console.log(`[${timestamp}][SDK:${category}] ${message}`);
  }
};
